export default "__VITE_ASSET__CR1Akdeq__"